// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-Main-modal__footer .o-Btn[data-v-18789e98]{margin-bottom:1em;text-transform:uppercase;font-weight:600;font-size:.875em;min-width:120px}@media (min-width: 544px){.c-Main-modal__footer .o-Btn[data-v-18789e98]{margin-bottom:0}}.o-Icon-bullet--close-blue[data-v-18789e98]:before{background-position:center;width:1.5em;height:1.5em}\n", ""]);
// Exports
module.exports = exports;
